import debounce from './../kobra/helpers/debouncer.js';
import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

export default () => {
    document.querySelector('#search-input').addEventListener('focusin', e => {
        if(document.querySelector('.sub-menu.visible')) {
            document.body.classList.remove('sub-menu-open');
            document.querySelector('.site-header__nav').setAttribute('aria-hidden', 'false');
            document.querySelector('.sub-menu.visible').classList.remove('visible');
            let main = document.querySelector('main');
            if(main) {
                main.classList.remove('blurred');
            }
            let footer = document.querySelector('#footer');
            if(!footer) {
                footer = document.querySelector('#footer-block');
            }
            footer.classList.remove('blurred');
        }
    });

    document.querySelector('#search-input').addEventListener('click', showSearch);
    document.querySelector('#search-input').addEventListener('input', debounce(search, 200));
    document.querySelector('#search-input').addEventListener('input', debounce(e => {

        const trimmedValue = e.srcElement.value.replaceAll(/\s/g,'');
        if(trimmedValue && trimmedValue.length > 2) {
            addCookie(e.srcElement.value);
        }
    }, 2000));

    document.querySelector('#search-form').addEventListener('submit', e => { e.preventDefault(); });

    document.querySelectorAll('.search__suggestion').forEach(btn => {
        btn.addEventListener('click', e => {
            document.querySelector('#search-input').value = e.srcElement.dataset.suggestion;
            search();
            addCookie(e.srcElement.dataset.suggestion);
        });
    });

    document.querySelectorAll('.clear-search').forEach(btn => {
        btn.addEventListener('click', clearSearch);
    });
    document.querySelectorAll('.close-search').forEach(btn => {
        btn.addEventListener('click', closeSearch);
    });

    document.querySelectorAll('.search-container__filter').forEach(btn => {
        btn.addEventListener('click', filterSearch);
    });
};

function showFilters() {
    document.querySelector('.search-container__filters').classList.add('search-container__filters--active');
    document.querySelector('.site-header__nav').classList.add('site-header__nav--hidden');
}

function hideFilters() {
    document.querySelector('.search-container__filters').classList.remove('search-container__filters--active');
    document.querySelector('.site-header__nav').classList.remove('site-header__nav--hidden');
}

function showSuggestions() {
    document.querySelector('.search__top').classList.remove('search__top--hidden');
    hideFilters();
}

function hideSuggestions() {
    document.querySelector('.search__top').classList.add('search__top--hidden');
    showFilters();
}

function showSearch() {
    document.body.classList.add('search-active');
    document.querySelector('.search-container').classList.add('search-container--active');
    document.querySelector('.search-container').setAttribute('aria-hidden', 'false');
    document.body.classList.add('stop-scrolling');
    showCloseButton();
}

function closeSearch() {
    clearSearch();
    document.body.classList.remove('search-active');
    document.querySelector('.search-container').classList.remove('search-container--active');
    document.querySelector('.search-container').setAttribute('aria-hidden', 'true');
    document.body.classList.remove('stop-scrolling');
    hideCloseButton();
}

function clearSearch() {
    document.querySelector('#search-input').value = '';
    search();
}

function showClearButton() {
    document.querySelectorAll('.form--search__clear').forEach(btn => {
        btn.classList.add('form--search__clear--vissible');
    });
}

function hideClearButton() {
    document.querySelectorAll('.form--search__clear').forEach(btn => {
        btn.classList.remove('form--search__clear--vissible');
    });
}

function showCloseButton() {
    document.querySelectorAll('.form--search__close').forEach(btn => {
        btn.classList.add('form--search__close--vissible');
    });
}

function hideCloseButton() {
    document.querySelectorAll('.form--search__close').forEach(btn => {
        btn.classList.remove('form--search__close--vissible');
    });
}

function addCookie(string = false) {
    if(!allowsCookies()) {
        return;
    }

    if(!string) {
        string = document.querySelector('#search-input').value;
    }

    if(!string) {
        return;
    }

    string += '|';
    document.querySelectorAll('.search__suggestion--previous').forEach(suggestion => {
        string += suggestion.dataset.suggestion + '|';
    })

    const date = new Date();
    date.setTime(date.getTime() + (14 * 24 * 60 * 60 * 1000));

    document.cookie = "search-strings=" + string + "; expires=" + date.toGMTString() + "; path=/";
}

function allowsCookies() {
    const cookies = decodeURIComponent(document.cookie);
    const name = 'CookieScriptConsent=';
    let ca = cookies.split(';');

    let value = '';

    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            value = c.substring(name.length, c.length);
        }
    }

    return value.includes('functionality');
}

function initSwiper() {
    document.querySelectorAll('.vehicle-swiper:not(.swiper-initialized)').forEach(vehicle => {
        new Swiper(vehicle, {
            allowTouchMove: true,
            slidesPerView: 1,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
        });
    })
}

function showNoResult() {
    document.querySelector('#search-results').innerHTML = '';
    document.querySelector('#no-search-results-string').innerHTML = document.querySelector('#search-input').value;
    document.querySelector('.search__no-result').classList.remove('search__no-result--inactive');
}

function hideNoResult() {
    document.querySelector('.search__no-result').classList.add('search__no-result--inactive');
}

function populateFilterNumbers(count, post_type) {
    if(count === 0) {
        document.querySelector('#count-' + post_type).parentNode.classList.add('search-container__filter--empty');
        document.querySelector('#count-' + post_type).innerHTML = count;
    } else {
        document.querySelector('#count-' + post_type).innerHTML = count;
        document.querySelector('#count-' + post_type).parentNode.classList.remove('search-container__filter--empty');
        if(post_type !== 'all') {
            document.querySelector('#count-' + post_type).parentNode.style.order = 1000-count;
        }
    }
}

function filterSearch(e) {
    document.querySelector('.search-container__filter--active').classList.remove('search-container__filter--active');
    e.srcElement.classList.add('search-container__filter--active');
    search();
}

function search() {
    Swiper.use([ Navigation ]);

    showSearch()

    const value = document.querySelector('#search-input').value;

    const trimmedValue = value.replaceAll(/\s/g,'');
    if(!trimmedValue || trimmedValue.length < 3) {
        hideClearButton();
        document.querySelector('#search-results').innerHTML = '';
        showSuggestions();
        return;
    }
    showClearButton();

    const filter = document.querySelector('.search-container__filter--active').dataset.filter;

    const form = new FormData();
    form.append('action', 'nobox_search');
    form.append('string', value);
    form.append('filter', filter);
    form.append('number', getNumberOfPosts());
    const params = new URLSearchParams(form);

    fetch(horizon.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params
    })
    .then(response => response.json())
    .then(data => {
        document.querySelectorAll('.search-container__filter--type').forEach(btn => { btn.classList.add('search-container__filter--empty'); })
        // document.querySelector('#search-results').innerHTML = '';

        if(data.data.result.length > 0) {
            hideNoResult();
            let html = '';
            data.data.result.forEach(d => {
                html += d.html;
                // document.querySelector('#search-results').insertAdjacentHTML('beforeEnd', d.html);
                populateFilterNumbers(d.hits_count, d.post_type);
            })

            document.querySelector('#search-results').innerHTML = html;
            hideSuggestions();
            initSwiper();
            initMore();
            // toggleTopResults(data.data.result);
        } else {
            showSuggestions()
            showNoResult();
        }
        populateFilterNumbers(data.data.total, 'all');
    });
}

function initMore() {
    document.querySelectorAll('.search__result-more').forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();

            let number = '';
            const active = btn.dataset.active;
            if(active === '1') {
                number = getNumberOfPosts();
            } else {
                number = '';
            }

            const form = new FormData();
            form.append('action', 'nobox_search_more');
            form.append('string', btn.dataset.string);
            form.append('posttype', btn.dataset.posttype);
            form.append('number', number);
            const params = new URLSearchParams(form);

            fetch(horizon.ajaxUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: params
            })
            .then(response => response.json())
            .then(data => {
                document.querySelector('#search-results .' + btn.dataset.posttype + '-container .search__results').innerHTML = '';
                data.data.result.forEach(d => {
                    document.querySelector('#search-results .' + btn.dataset.posttype + '-container .search__results').insertAdjacentHTML('beforeEnd', d.html);
                })
                initSwiper();

                if(active === '1') {
                    btn.dataset.active = '0';
                } else {
                    btn.dataset.active = '1';
                }
            });
        });
    })
}

function getNumberOfPosts() {
    if(window.screen.width <= 1024 && window.screen.width > 800) {
        return 3;
    }

    return 4;
}

function toggleTopResults(result) {
    const topResults = document.querySelector('.search__result-category.all-container');
    if(result.length > 2) {
        topResults.classList.remove('search__result-category--hidden');
    } else {
        topResults.classList.add('search__result-category--hidden');
    }

}
